const pluralize = (value: number, word: string, end?: string, plural = `${word}${end || "s"}`) =>
  [1, -1].includes(Number(value)) ? word : plural;

export default pluralize;
